import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Presentation, PresentationRequest } from './PresentationTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Presentation>>('/author/presentations/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Presentation>(`/author/presentations/${id}`).then(getData);
}

export function edit(id: Id, request: PresentationRequest) {
  return axios.put<Presentation>(`/author/presentations/${id}`, request).then(getData);
}

export function create(request: PresentationRequest) {
  return axios.post<Presentation>(`/author/presentations`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/presentations/${id}`).then(getData);
}
